export const getPaymentMethodLabel = (method) => {
  const map = {
    card: "카드",
    bank_transfer: "계좌이체",
  };

  return map[method] ?? method ?? "-";
};
